import authUtils from '../authUtils';

const { DEFAULT_ALI_OFFICIAL_ACCOUNTS_ID } = authUtils.config;
const wechatApi = authUtils.wechatApi;
const readerCenterApi = authUtils.readerCenterApi;

class AliAuthorize {
  constructor({
    query,
    snsapiBase,
    defaultAuthorize
  }) {
    this.query = query || {};
    this.snapsis = snsapiBase || false;
    this.defaultAuthorize = defaultAuthorize || false; // 是否需要进入时授权
  }

  checkLogged() {
    const { wechatUserId, userType } = authUtils.getCookieUser();
    // 是否真实用户
    return userType === authUtils.CONSTANT.USER_TYPE_REGULAR && !!wechatUserId;
  }

  /**
   * 检查是否存在openid
   * @returns {boolean}
   */
  checkOpenid() {
    return !!this.query.openid;
  }

  /**
   * 通过openid获取用户信息
   */
  getByOpenid() {
    const data = {
      openId: this.query.openid,
      officialAccountsId: DEFAULT_ALI_OFFICIAL_ACCOUNTS_ID
    };
    return readerCenterApi.getUserInfoByOpenId(data);
  }

  /**
   * 进入默认授权
   */
  enterAuthorize() {
    return this.defaultAuthorize;
  }

  /**
   * 是否有code信息
   * @returns {boolean}
   */
  checkCode() {
    return !!this.query.auth_code;
  }

  /**
   * 通过code获取用户信息
   * @returns Promise
   */
  getByCode() {
    const { auth_code, scope, phone } = this.query;
    const data = {
      scope,
      phone,
      code: auth_code,
      officialAccountsId: DEFAULT_ALI_OFFICIAL_ACCOUNTS_ID
    };
    return wechatApi.aliUser(data);
  }

  /**
   * 发起授权
   */
  forward() {
    //重定向到微信授权界面
    const baseUrl = `${window.location.origin}/wechat/aliAuth/forward?`;
    return window.location = (`${baseUrl}${authUtils.json2params({
      officialAccountsId: DEFAULT_ALI_OFFICIAL_ACCOUNTS_ID,
      redirectUrl: encodeURIComponent(AliAuthorize.getAuthorizeUrl()),
      snsapiBase: this.snapsis
    })}`);
  }

  static getAuthorizeUrl() {
    const href = window.location.href,
      search = window.location.search;
    if(search.indexOf('code') > -1) {
      const query = authUtils.params2json(search.slice(1));
      delete query.auth_code;
      delete query.scope;
      delete query.app_id;
      return (
        window.location.origin +
        window.location.pathname +
        '?' +
        authUtils.json2params(query)
      );
    } else {
      return href;
    }
  }
}

export default AliAuthorize;
